import { InputHTMLAttributes, RefObject } from 'react'
import clsx from 'clsx'
import $form from '@tandem/ui/form.css'

export interface TextInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'onBlur'> {
  field: any
  onValueChange?: (value: string) => void
  ref?: RefObject<HTMLInputElement|null>
}

export default function TextInput({ field, onValueChange, ...inputProps }: TextInputProps) {
  return (
    <input
      type='text'
      {...inputProps}
      value={field.state.value ?? ''}
      onChange={(e) => {
        field.handleChange(e.target.value)
        onValueChange?.(e.target.value)
      }}
      onBlur={field.handleBlur}
      class={clsx(inputProps.class, {
        [$form.error]: !field.state.meta.isValid && field.state.meta.isTouched,
      })}
      placeholder={inputProps.placeholder ?? ' '}
    />
  )
}
